import { render } from "./Survey2024All.vue?vue&type=template&id=5efcafa5"
import script from "./Survey2024All.vue?vue&type=script&lang=js"
export * from "./Survey2024All.vue?vue&type=script&lang=js"

import "./Survey2024All.vue?vue&type=style&index=0&id=5efcafa5&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__